import { getTeamLabelByNumber } from '@/components/pages/TraderMode/utils/utils'

let previousThrowsTableValues
let isFirstStartOver = true

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    '1_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 1
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '1_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '1_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '1/WD'
      })
      this.setScore(event)
    },
    '1_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '1/NB'
      })
      this.setScore(event)
    },
    '2_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 2
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '2_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '2_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '2/WD'
      })
      this.setScore(event)
    },
    '2_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '2/NB'
      })
      this.setScore(event)
    },
    '3_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 3
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '3_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '3_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '3/WD'
      })
      this.setScore(event)
    },
    '3_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '3/NB'
      })
      this.setScore(event)
    },
    '4_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 4
      })
      this.setScore(event)
    },
    '4_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '4_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '4/WD'
      })
      this.setScore(event)
    },
    '4_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '4/NB'
      })
      this.setScore(event)
    },
    '5_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 5
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '5_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '5_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '5/WD'
      })
      this.setScore(event)
    },
    '5_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '5/NB'
      })
      this.setScore(event)
    },
    '6_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 6
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '6_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '6_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '6/WD'
      })
      this.setScore(event)
    },
    '6_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '6/NB'
      })
      this.setScore(event)
    },
    '7_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 7
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '7_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '7_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '7/WD'
      })
      this.setScore(event)
    },
    '7_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '7/NB'
      })
      this.setScore(event)
    },
    '8_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 8
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '8_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '8_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '8/WD'
      })
      this.setScore(event)
    },
    '8_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '8/NB'
      })
      this.setScore(event)
    },
    '9_RUN' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 9
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '9_RUN_OUT' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '9_WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '9/WD'
      })
      this.setScore(event)
    },
    '9_NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '9/NB'
      })
      this.setScore(event)
    },
    'START_INNING' (event) {
      isFirstStartOver = true
      this.setIngameProperty({
        property: 'currentTeam',
        value: event.TeamNumber
      })
    },
    'START_OVER' (event) {
      previousThrowsTableValues = this.getIngameData.shootoutsLog
      this.clearShootoutStatistic()
      if (!isFirstStartOver) {
        this.setIngameProperty({
          team: event.TeamNumber,
          property: 'overCount',
          value: this.getIngameData.overCount[getTeamLabelByNumber(event.TeamNumber)] + 1
        })
      }
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: 0
      })
      isFirstStartOver = false
    },
    'BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    'DOT_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 0
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    'WIDE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'WD'
      })
      this.setScore(event)
    },
    'WIDE_WITH_RUN' (event) {
      this.setScore(event)
    },
    'NO_BALL' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'NB'
      })
      this.setScore(event)
    },
    'NO_BALL_WITH_RUN' (event) {
      this.setScore(event)
    },
    '0_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'LB',
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '0_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'B',
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '1_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '1/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '1_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '1/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '2_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '2/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '2_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '2/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '3_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '3/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '3_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '3/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '4_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '4/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '4_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '4/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '5_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '5/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '5_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '5/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '6_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '6/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '6_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '6/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '7_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '7/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '7_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '7/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '8_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '8/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '8_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '8/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '9_LEG_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '9/LB'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    '9_BYE' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: '9/B'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      this.setScore(event)
    },
    'WICKETS' (event) {
      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(event.TeamNumber) || 'home',
        value: 'W'
      })
      this.setIngameProperty({
        team: event.TeamNumber,
        property: 'throwNumber',
        value: this.getIngameData.throwNumber[getTeamLabelByNumber(event.TeamNumber)] + 1
      })
      const currentTeam = getTeamLabelByNumber(event.TeamNumber)

      let home = this.getIngameData.wickets.home
      let away = this.getIngameData.wickets.away

      if (currentTeam === 'home') {
        home = home + 1
      } else {
        away = away + 1
      }

      this.setIngameProperty({
        property: 'wickets',
        value: {
          home,
          away
        }
      })
    },
    'WICKETS_SENDABLE' (event) {
      const currentTeam = getTeamLabelByNumber(event.TeamNumber)

      let home = this.getIngameData.wickets.home
      let away = this.getIngameData.wickets.away

      if (currentTeam === 'home') {
        home = home + 1
      } else {
        away = away + 1
      }

      this.setIngameProperty({
        property: 'wickets',
        value: {
          home,
          away
        }
      })
    },
    'MATCH_FORMAT' (event) {
      const { extra } = event
      const {
        kits,
        matchFormat,
        timer_speed_up: timerSpeedUp
      } = extra

      this.setMatchFormat({
        kits,
        matchFormat,
        timerSpeedUp
      })
    },
    'CANCEL' (event) {
      const { RelatedEventNumber } = event
      const { getEventCache } = this
      const relatedEvent = getEventCache[RelatedEventNumber]
      const { TeamNumber, EventCode } = relatedEvent
      const pointEvents = [
        '1_RUN',
        '2_RUN',
        '3_RUN',
        '4_RUN',
        '5_RUN',
        '6_RUN',
        '7_RUN',
        '8_RUN',
        '9_RUN',
        '1_RUN_OUT',
        '2_RUN_OUT',
        '3_RUN_OUT',
        '4_RUN_OUT',
        '5_RUN_OUT',
        '6_RUN_OUT',
        '7_RUN_OUT',
        '8_RUN_OUT',
        '9_RUN_OUT',
        '1_NO_BALL',
        '2_NO_BALL',
        '3_NO_BALL',
        '4_NO_BALL',
        '5_NO_BALL',
        '6_NO_BALL',
        '7_NO_BALL',
        '8_NO_BALL',
        '9_NO_BALL',
        '1_WIDE',
        '2_WIDE',
        '3_WIDE',
        '4_WIDE',
        '5_WIDE',
        '6_WIDE',
        '7_WIDE',
        '8_WIDE',
        '9_WIDE',
        'WICKETS',
        '0_LEG_BYE',
        '1_LEG_BYE',
        '2_LEG_BYE',
        '3_LEG_BYE',
        '4_LEG_BYE',
        '5_LEG_BYE',
        '6_LEG_BYE',
        '7_LEG_BYE',
        '8_LEG_BYE',
        '9_LEG_BYE',
        '0_BYE',
        '1_BYE',
        '2_BYE',
        '3_BYE',
        '4_BYE',
        '5_BYE',
        '6_BYE',
        '7_BYE',
        '8_BYE',
        '9_BYE',
        'BYE',
        'WIDE',
        'NO_BALL',
        'NO_BALL_WITH_RUN',
        'DOT_BALL'
      ]

      if (pointEvents.includes(EventCode)) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })

        if (
          this.getIngameData.throwNumber[getTeamLabelByNumber(TeamNumber)] > 0 &&
          !['NO_BALL', 'NO_BALL_WITH_RUN', 'WIDE'].includes(EventCode)
        ) {
          this.setIngameProperty({
            team: TeamNumber,
            property: 'throwNumber',
            value: this.getIngameData.throwNumber[getTeamLabelByNumber(TeamNumber)] - 1
          })
        }
      }

      if (EventCode === 'START_OVER') {
        const currentOverCount = this.getIngameData.overCount[getTeamLabelByNumber(TeamNumber)]

        this.setIngameProperty({
          team: TeamNumber,
          property: 'overCount',
          value: currentOverCount ? currentOverCount - 1 : 0
        })
        this.setIngameProperty({
          team: TeamNumber,
          property: 'throwNumber',
          value: 5
        })
        previousThrowsTableValues[getTeamLabelByNumber(TeamNumber)].pop()
        this.setIngameProperty({
          team: TeamNumber,
          property: 'shootoutsLog',
          value: previousThrowsTableValues[getTeamLabelByNumber(TeamNumber)]
        })
      }

      if (EventCode === 'WICKETS' || EventCode === 'WICKETS_SENDABLE') {
        const currentTeam = getTeamLabelByNumber(TeamNumber)
        let home = this.getIngameData.wickets.home
        let away = this.getIngameData.wickets.away

        if (currentTeam === 'home') {
          home = home - 1
        } else {
          away = away - 1
        }

        this.setIngameProperty({
          property: 'wickets',
          value: {
            home,
            away
          }
        })
      }

      this.setScore(event)
      this.setCanceled(event)
      this.refreshDelayedEvents(event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {}
}
